import { FC } from "react"
import { Rules } from "../../../module/users/containers/rules"

export const RulesPage: FC = () => <Rules />
